<template>
  <dv-scroll-board :config="config" style="width:100%;height:340px" />
</template>

<script>
//专区排行
export default {
  name: "MouthRanking2",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {

    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };

    this.$api.zgu_mouth_ranking(data).then(res=>
    {
      this.config = {
        header: ['单位名称', '消费金额', '帮扶金额'],
        rowNum:[6],
        data: res,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [40,320,100,100],
        align: ['center']
      }
    })


  },
  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>